// extracted by mini-css-extract-plugin
export var emailBlockLink = "_oj-0";